import { UserLogin } from 'app/shared/models';
import { Observable, ReplaySubject } from 'rxjs';

import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UserLoginService {
  private _user: ReplaySubject<UserLogin> = new ReplaySubject<UserLogin>(1);

  set user(value: UserLogin) {
    this._user.next(value);
  }

  get user$(): Observable<UserLogin> {
    return this._user.asObservable();
  }
}
